export const PARTNERSHIP_CONSTANTS = {
  title: "Premium OneMind-Zadara Partnership ",
  desc: {
    text: "As a strategic partner of Zadara, OneMind brings deeper platform access, faster support pathways, and co-engineered solutions that unlock real agility and savings for our clients. Our joint architecture sessions and joint service mesh blueprints ensure seamless workload performance from edge to core. ",

    highlight: [
      "Zadara",
      "deeper",
      "platform access",
      "faster",
      "support pathways",
      "co-engineered solutions",
    ],
  },
};
